import { faLink } from '@fortawesome/free-solid-svg-icons'
import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
import type { ReportColumnType, ReportResponse } from '../../../modules/reportsApi/catalog/report-catalog'

const COL_TYPE_MAP: Record<ReportColumnType, GridColTypeEnum> = {
    string: GridColTypeEnum.string,
    int: GridColTypeEnum.int,
    float: GridColTypeEnum.float,
    currency: GridColTypeEnum.float_2,
    percent: GridColTypeEnum.percent,
    date: GridColTypeEnum.date,
    datetime: GridColTypeEnum.datetime,
    time: GridColTypeEnum.time,
    phone: GridColTypeEnum.phone,
    email: GridColTypeEnum.email,
    boolean: GridColTypeEnum.string,
}

// monta um GridClass genérico a partir do contrato ReportResponse (columns/rows) — qualquer relatório
// migrado pro backend passa a ter grid pronto sem precisar montar GridCol/GridLine manualmente
export function buildReportGrid(response: ReportResponse): GridClass {
    const grid: GridClass = new GridClass()
    // grid.title = response.title
    grid.subtitle = response.notes || ''
    // o título não vai pro grid (o Zframe da tela já mostra), mas o CSV precisa dele: sem fileName, o nome
    // do arquivo sairia do subtitle, que aqui são as observações do relatório — um parágrafo inteiro.
    grid.fileName = response.title || ''
    grid.fontSize = '14px'

    for (const col of response.columns) {
        grid.cols.push(
            new GridCol({
                content: col.label,
                type: COL_TYPE_MAP[col.type] ?? GridColTypeEnum.string,
                showTotal: col.showTotal ?? false,
                isGroup: col.isGroup,
                show: col.show ?? true,
            }),
        )
    }

    for (const row of response.rows) {
        const line = new GridLine()
        for (const col of response.columns) {
            const raw = row[col.key]
            line.slots.push({ content: col.type === 'boolean' ? (raw ? 'Sim' : 'Não') : raw })
        }
        grid.lines.push(line)
    }

    // params já vem do backend exatamente como foi usado pra gerar esta resposta (ReportResponse.params)
    // — o popover monta o link de export com esses mesmos filtros/período, sem precisar duplicar o
    // estado dos filtros aqui
    grid.acts.push(
        new GridButton({
            icon: faLink,
            label: 'Link',
            mobileShowLabel: false,
            callback: () => window.popover({ act: 'report-export-link', data: { reportId: response.report, params: response.params } }),
        }),
    )

    return grid
}
